var _rect, _path, _path2, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 200,
    viewBox: "0 0 166 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 200,
    transform: "matrix(-1 0 0 1 165.5 0)",
    fill: "#EF233C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139 99.5V155H83.5M83.5 44H28V99.5",
    stroke: "white",
    strokeWidth: 15.8571
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.141 99.5002L123.141 59.8574H83.4978M83.4978 139.143H43.8549V99.5002",
    stroke: "#2B2D42",
    strokeWidth: 15.8571
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31.7143,
    height: 31.7143,
    transform: "matrix(0 -1 -1 0 115.215 131.214)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 31.7143,
    height: 31.7143,
    transform: "matrix(0 -1 -1 0 83.5 99.4995)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCreditCard);
export default __webpack_public_path__ + "static/media/UserCreditCard.4a9b189a3b2bc36461fb7e236ca9f7ee.svg";
export { ForwardRef as ReactComponent };